import _ from "lodash";
// import draftToHtml from "draftjs-to-html";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
  };
};

const fetchPromotionCategoriesApi = () => {
  return fetchApi("promotion_categories")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchPromotionCategoriesApi };



// WEBPACK FOOTER //
// ./src/services/page/promotioncategories.js